/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var EXAM_PRIORITY_ENUM;
(function (EXAM_PRIORITY_ENUM) {
    EXAM_PRIORITY_ENUM["URGENT"] = "URGENT";
    EXAM_PRIORITY_ENUM["IMPORTANT"] = "IMPORTANT";
    EXAM_PRIORITY_ENUM["NORMAL"] = "NORMAL";
})(EXAM_PRIORITY_ENUM || (EXAM_PRIORITY_ENUM = {}));
